import { svg } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { interpolate, svgTransition } from '../../../../visualizations/common/directives/svgTransition.js';
import { highlightYTargetStateProvider, yTarget } from '../../types.js';
import { ValueScale } from './ValueScale.js';
import { ValueFormatter } from '../../../../visualizations/common/format.js';
import { timing } from '../../animation.js';
import { getTickPlacementInfo } from './utils.js';
import { defaultOpacityOnInactiveHighlight } from '../../style.js';
export function ValueAxis({
  valueScale,
  valueFormatter,
  yTarget,
  animate,
  highlightYTargetStateProvider
}: {
  valueScale: ValueScale;
  valueFormatter: ValueFormatter;
  yTarget: yTarget;
  animate: boolean;
  highlightYTargetStateProvider: highlightYTargetStateProvider;
}) {
  const opacity = highlightYTargetStateProvider(yTarget) === 'inactive' ? defaultOpacityOnInactiveHighlight : 1;
  return svg`
    <g transform="translate(0, 0)" fill="none" class="value-axis">
      ${repeat(valueScale.ticks, tick => `value-axis:${valueFormatter.formatValue(tick)}`, tick => {
    const {
      x,
      y,
      textAnchor,
      text,
      alignment,
      typography
    } = getTickPlacementInfo(valueScale, yTarget, valueFormatter, tick);
    return svg`<text
            class="one-ux-typography--${typography}"
            alignment-baseline=${alignment}
            text-anchor=${textAnchor}
            fill="var(--one-ux-palette--brand-neutral-600)"
            x=${x}
            ${svgTransition({
      timing: timing(animate),
      attributes: {
        x: interpolate.constant(x, x => x.toString()),
        y: interpolate.constant(y, y => y.toString()),
        opacity: interpolate.standard(0, opacity, 0)
      }
    })}>
            ${text}
          </text>`;
  })}
    </g>
  `;
}